import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_cmdk__ from "cmdk";
import * as __WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__ from "./input.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__ from "./command.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__ from "./popover.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__ from "../lib/SIcon.mjs";
const InputSelectContext = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createContext(void 0);
const useInputSelect = ()=>{
    const context = __WEBPACK_EXTERNAL_MODULE_react__.useContext(InputSelectContext);
    if (!context) throw new Error("useInputSelect must be used within a InputSelectProvider");
    return context;
};
const InputSelectProvider = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ children }, ref)=>{
    const inputRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const [value, setValue] = __WEBPACK_EXTERNAL_MODULE_react__.useState("");
    const [open, setOpen] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const contextValue = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            inputRef,
            open,
            setOpen,
            value,
            setValue
        }), [
        open,
        value
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InputSelectContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command, {
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
                open: open,
                children: children
            })
        })
    });
});
InputSelectProvider.displayName = "InputSelectProvider";
const InputSelect = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...props }, ref)=>{
    const { onChange, ...rest } = props;
    const { setOpen, value, setValue, inputRef } = useInputSelect();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverAnchor, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Input, {
            ref: inputRef,
            onFocus: ()=>{
                setOpen(true);
            },
            onBlur: ()=>{
                setOpen(false);
            },
            value: value,
            onValueChange: (value)=>{
                setValue(value);
                onChange?.(value);
            },
            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("w-full", className),
            asChild: true,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__.Input, {
                ...rest
            })
        })
    });
});
InputSelect.displayName = "InputSelect";
const InputSelectContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, children, ...props }, ref)=>{
    const filteredCount = (0, __WEBPACK_EXTERNAL_MODULE_cmdk__.useCommandState)((state)=>state.filtered.count);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
        ref: ref,
        align: "start",
        sideOffset: 4,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("w-fit p-0 rounded-xl overflow-hidden transition-opacity duration-150 min-w-[100px]", 0 === filteredCount ? "opacity-0" : "opacity-100", className),
        onOpenAutoFocus: (e)=>{
            e.preventDefault();
        },
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandList, {
            className: "p-1",
            children: children
        })
    });
});
InputSelectContent.displayName = "InputSelectContent";
const InputSelectGroup = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandGroup, {
        ref: ref,
        ...props
    }));
InputSelectGroup.displayName = "InputSelectGroup";
const InputSelectItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, icon, value, ...props }, ref)=>{
    const { onSelect, ...rest } = props;
    const { setValue, inputRef } = useInputSelect();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandItem, {
        ref: ref,
        value: value,
        onSelect: (selectedValue)=>{
            setValue(selectedValue);
            onSelect?.(selectedValue);
            inputRef.current?.blur();
        },
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("relative flex h-[30px] group/item cursor-default select-none items-center rounded-md font-normal px-2.5 text-sm outline-none text-foreground/[0.75] data-[disabled=true]:pointer-events-none data-[selected=true]:bg-grayscale-dark data-[selected=true]:text-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 transition-colors", "gap-6 justify-between", className),
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                    type: icon,
                    className: "!size-3.5 text-secondary-foreground group-data-[selected=true]/item:text-foreground transition-colors"
                }) : null,
                props.children
            ]
        })
    });
});
InputSelectItem.displayName = "InputSelectItem";
const InputSelectSeparator = __WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandSeparator;
export { InputSelect, InputSelectContent, InputSelectGroup, InputSelectItem, InputSelectProvider, InputSelectSeparator };
